import { ELEMENT_ATTRIBUTE_GROUP, ELEMENT_GROUPS } from './../utils';

const MediaViewerElementFields = {
  group: ELEMENT_GROUPS.MEDIA,
  label: 'Media Viewer',
  icon: 'DocumentIcon',
  description: 'Adds a Media Viewer to the Screen',
  properties: [
    {
      label: 'Media Type',
      name: 'mediaType',
      editor: 'dropdown',
      default: 'file',
      options: [
        { label: 'Other File', value: 'file' },
        { label: 'PDF', value: 'pdf' },
        { label: 'Audio', value: 'audio' },
        { label: 'Image', value: 'image' },
        { label: 'Video', value: 'video' },
        { label: 'Url', value: 'url' }
      ],
      displayWhen: [
        {
          field: 'datasourceId',
          operator: 'IS_EMPTY',
          value: []
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Media Url',
      name: 'url',
      editor: 'textbox',
      displayWhen: [
        {
          field: 'datasourceId',
          operator: 'IS_EMPTY',
          value: []
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Data Binding Source',
      name: 'datasourceId',
      description: 'Choose a content type this element will get its data from',
      editor: 'dropdown',
      function: {
        name: 'getDynamicDataSources',
        params: ['app.id']
      },
      default: '',
      displayWhen: [
        {
          field: 'databindingDisabled',
          operator: '!==',
          value: true
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Data Binding Media Type Field',
      name: 'mediaTypeSourceField',
      editor: 'dropdown',
      description:
        'The field from the underlying record that will be used to determine the type of media',
      default: '',
      options: [],
      function: {
        name: 'getDynamicDataSourceFields',
        params: ['app.id', 'datasourceId']
      },
      displayWhen: [
        {
          field: 'datasourceId',
          operator: 'IS_NOT_EMPTY',
          value: []
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Data Binding Media Source Field',
      name: 'sourceField',
      editor: 'dropdown',
      description:
        'The field from the underlying record that will be used for the url of the PDF file',
      default: '',
      options: [],
      function: {
        name: 'getDynamicDataSourceFields',
        params: ['app.id', 'datasourceId']
      },
      displayWhen: [
        {
          field: 'datasourceId',
          operator: 'IS_NOT_EMPTY',
          value: []
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    'color',
    {
      label: 'Width (Video)',
      name: 'widthVideo',
      editor: 'number',
      description: 'The width of the viewer',
      default: 245,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Height (Video)',
      name: 'heightVideo',
      editor: 'number',
      description: 'The height of the viewer',
      default: 170,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Width (PDF)',
      name: 'widthPDF',
      editor: 'number',
      description: 'The width of the viewer',
      default: 245,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Height (PDF)',
      name: 'heightPDF',
      editor: 'number',
      description: 'The height of the viewer',
      default: 170,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Width (Audio Player)',
      name: 'widthAudioPlayer',
      editor: 'number',
      description: 'The width of the viewer',
      default: 245,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Height (Audio Player)',
      name: 'heightAudioPlayer',
      editor: 'number',
      description: 'The height of the viewer',
      default: 170,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Width (Image)',
      name: 'widthImage',
      editor: 'number',
      description: 'The width of the viewer',
      default: 245,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Height (Image)',
      name: 'heightImage',
      editor: 'number',
      description: 'The height of the viewer',
      default: 170,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Border Width',
      name: 'borderWidth',
      editor: 'number',
      description: 'The border width of the media element',
      default: 0,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Border Radius',
      name: 'borderRadius',
      editor: 'number',
      description: 'The border radius of the media element',
      default: 0,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Border Color',
      name: 'borderColor',
      editor: 'color',
      description: 'The border color of the media element',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    'margin',
    {
      name: 'padding',
      label: 'Padding',
      description: '',
      editor: 'boundary',
      type: 'string',
      default: '10 10 10 10',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      name: 'backgroundColor',
      label: 'Button Background Color',
      description: '',
      editor: 'color',
      type: 'string',
      default: '#182fa4',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    }
  ]
};

export default MediaViewerElementFields;
